

import { Component, EventEmitter, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { query } from '@angular/animations';
import { TransportAssetDetailsModalComponent } from '../transport-asset-details-modal/transport-asset-details-modal.component';


@Component({
  selector: 'app-transport-asset-landing',
  standalone: false,
  templateUrl: './transport-asset-landing.component.html',
  styleUrl: './transport-asset-landing.component.scss'
})
export class TransportAssetLandingComponent {

  action_idx: any = null;

  dataList: any[] = [
    {
      id: 1,
      ticketNumber: 'ABC123',
      soldStatus: 'SOLD',
      assignStatus: 'ASSIGNED',
      assignedTo: 'john doe',
      createdAt: '2025-04-18'
    },
    {
      id: 2,
      ticketNumber: 'DEF456',
      soldStatus: 'UNSOLD',
      assignStatus: 'UN_ASSIGNED',
      assignedTo: null,
      createdAt: '2025-04-17'
    },
    {
      id: 3,
      ticketNumber: 'GHI789',
      soldStatus: 'SOLD',
      assignStatus: 'UN_ASSIGNED',
      assignedTo: 'jane smith',
      createdAt: '2025-04-16'
    },
    {
      id: 4,
      ticketNumber: 'JKL012',
      soldStatus: 'UNSOLD',
      assignStatus: 'ASSIGNED',
      assignedTo: 'michael brown',
      createdAt: '2025-04-15'
    }
  ];

  form!: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 20;
  selectedLimit: number = 10;


  errorFetchingData: boolean = false;


  @Output() onConfirmClicked = new EventEmitter();
  vehicleTypes: any[] = [];
  periodFilter: number;

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  clearSearchFilters() {
    this.form.reset()
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      phoneNumber: [''],
      plateNumber: [''],
      transportId: [''],
      route: [''],
      startDate: [''],
      endDate: [''],
    });


    this.periodFilter = this.route.snapshot.params["period"];


    this.search();
  }




  viewTaxpayer(id: number): void {
    this.router.navigate(['/admin/asset-management/transport/details'], { queryParams: { id } })
  }

  editTaxpayer(data: number): void {
    let dialog = this.dialog.open(TransportAssetDetailsModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed', 'custom-dialog-lg'],
      data
    })

    dialog.afterClosed().subscribe((data: any) => {
      if (data.reload == true) {
        this.search()
      }
    })
  }


  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();

  }

  search() {
    this.dataList = [];
    this.searchedDataNotFound = false;
    this.errorFetchingData = false
    this.isSearching = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();
    const formValues = this.form.value;

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);

    formValues.phoneNumber != null && formData.append("phoneNumber", formValues.phoneNumber);
    formValues.plateNumber != null && formData.append("plateNumber", formValues.plateNumber);
    formValues.transportId != null && formData.append("transportId", formValues.transportId);
    formValues.route != null && formData.append("route", formValues.route);
    formValues.startDate != null && formData.append("startDate", formValues.startDate);
    formValues.endDate != null && formData.append("endDate", formValues.endDate);
    this.periodFilter != null && formData.append("period", this.periodFilter);



    this.apiService
      .post('/transport/paged', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }



          this.dataList = response.data;

        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true
        }
      );
  }

  openDialogRef(data?: any) {
    // let dialogRef = this.dialog.open(GenerateTicketModalComponent, {
    //   width: '450px',
    //   backdropClass: 'modal-form-backdrop',
    //   hasBackdrop: true,
    //   panelClass: ['modal-form'],
    //   disableClose: true,

    //   data,
    // });

    // return dialogRef;
  }



  back() {
    this.router.navigate(['/admin/asset-management'])
  }
}
